import { ABTestVariationEnum } from '@inter-ikea-kompis/enums';
import { applicationSettings } from '../settings/application';
import { getCookieConsentService } from '../services/ServiceHandler';
import { selectDexfSettings } from '../state/dexfSettings/dexfSettingsSelectors';
import store from '../state';

/**
 * Initialize AB test from DEXF-settings
 *
 */
export const initializeDexfABTests = async () => {
  try {
    const consentLevel = 2;
    const analyticsCookieConsentService = getCookieConsentService();
    if (!(await analyticsCookieConsentService.hasCookieConsent(consentLevel)))
      return;

    try {
      const dexfSettings = selectDexfSettings(store.getState());
      if (!dexfSettings?.abtesting?.abTestingId) {
        return null;
      }

      const abTestId = dexfSettings.abtesting.abTestingId;
      handleAbVariation(abTestId);
    } catch (error) {
      // Handle error.
      console.log(error);
    }
  } catch (error) {
    console.warn('Cant fetch consent, assume no consent');
  }
};

/**
 * Returns AB test variation if it's in local storage.
 *
 * @param abTestId
 */
export const getLocalStorageAbVariation = (abTestId: string) => {
  const localStorageVariation = localStorage.getItem(abTestId);
  if (localStorageVariation) return localStorageVariation;
  return null;
};

/**
 * Check if AB test exist in local storage, else create new.
 *
 * @param abTestId
 */
const handleAbVariation = (abTestId: string) => {
  const plannerAbTestId = abTestId.concat(
    '_',
    applicationSettings.applicationName
  );

  const variationFound = getLocalStorageAbVariation(plannerAbTestId);
  if (variationFound) {
    return variationFound;
  }

  return setTestVariation(plannerAbTestId);
};

/**
 * Set AB test name with a random variation between A/B
 *
 * @param abTestId
 */
const setTestVariation = (plannerAbTestId: string) => {
  const variation =
    Math.random() < 0.5 ? ABTestVariationEnum.A : ABTestVariationEnum.B;

  localStorage.setItem(plannerAbTestId, variation);
  return variation;
};
